// Application configuration constants

// Pagination defaults
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
  WIKI_PAGE_SIZE: 50,
  ADMIN_PAGE_SIZE: 20,
} as const;

// Timeouts
export const TIMEOUTS = {
  DEBOUNCE_SEARCH: 300,
  TOAST_DURATION: 5000,
  SESSION_CHECK_INTERVAL: 60000, // 1 minute
} as const;

// File upload limits
export const FILE_LIMITS = {
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  MAX_FILES_COUNT: 5,
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
} as const;

// External links
export const EXTERNAL_LINKS = {
  TELEGRAM_CHAT: 'https://telegram.me/OdiumWorld_chat',
  TELEGRAM_NEWS: 'https://telegram.me/OdiumWorld_RvR',
  DISCORD: 'https://discord.gg/hm7frpnEPE',
  YOUTUBE: 'https://www.youtube.com/@OWrvr',
  // Пост с правилами выдачи предстартовых наград — открывается из окна после регистрации
  // (`RegistrationBonusDialog`). ЗАГЛУШКА: адрес самого поста заказчик ещё не давал, пока
  // ведёт на новостной канал. Появится ссылка — поменять только здесь.
  TELEGRAM_BONUS_POST: 'https://telegram.me/OdiumWorld_RvR',
  // ЗБТ application form — also used by the (currently disabled) /testers page.
  ZBT_FORM: 'https://docs.google.com/forms/d/e/1FAIpQLSfNx3lvYBfsIHjm8JpNi4-NQ7B1utxge5PcvMm-o7Ut-o7OFw/viewform',
} as const;

// API configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080',
  ASSETS_URL: '/assets',
} as const;

// OAuth configuration
export const OAUTH_CONFIG = {
  GOOGLE: {
    CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '507204093738-va82gfv843hibio644ubg3324g4r842s.apps.googleusercontent.com',
    REDIRECT_URI: process.env.REACT_APP_GOOGLE_REDIRECT_URI || 'https://odiumworld.com/auth/google/callback',
  },
  YANDEX: {
    CLIENT_ID: process.env.REACT_APP_YANDEX_CLIENT_ID || '3ec6a7f5df9248379c6c28a82ac04f3c',
    REDIRECT_URI: process.env.REACT_APP_YANDEX_REDIRECT_URI || 'https://odiumworld.com/auth/yandex/callback',
  },
  VK: {
    CLIENT_ID: process.env.REACT_APP_VK_CLIENT_ID || '54318337',
    REDIRECT_URI: process.env.REACT_APP_VK_REDIRECT_URI || 'https://odiumworld.com/auth/vk/callback',
  },
} as const;

// Locale configuration
export const LOCALES = {
  DEFAULT: 'ru',
  SUPPORTED: ['ru', 'en', 'uk'] as const,
} as const;

export type SupportedLocale = typeof LOCALES.SUPPORTED[number];

// Storage keys for localStorage
export const STORAGE_KEYS = {
  LOCALE: 'locale',
  PKCE_CODE_VERIFIER: 'vk_code_verifier',
  PKCE_STATE: 'vk_state',
} as const;

// Custom event names
export const EVENTS = {
  LOCALE_CHANGED: 'localeChanged',
} as const;

// Animation/transition durations
export const ANIMATION = {
  DIALOG_CLOSE_DELAY: 150,
} as const;

// Homepage countdown timer
export const COUNTDOWN = {
  ENABLED: true,
  TARGET_DATE: '2026-10-02T17:00:00Z', // October 2, 2026 20:00 MSK (UTC+3) — server launch
  COUNT_UP_AFTER: true, // After the target date the timer keeps running upward — how long the server has been up
} as const;

// Гайд выкатываем публике по одной секции. Здесь — ключи тех, что уже открыты всем:
// гость видит только их и в самой странице, и в боковой навигации, залогиненный — весь гайд.
// Ключ тот же, что в адресе (`/guide?guide=balancer`), в `sidenav.groups` локалей и в `GUIDE_KEY`
// самой секции. Выпустить следующий гайд = дописать сюда один ключ, больше ничего.
export const PUBLIC_GUIDE_SECTIONS: readonly string[] = [
  'balancer',
  'caps',
  'vitality',
  'settings',
  'autohunt',
  'synthesis',
  'brooch',
  'referral',
  'caravans',
  'weapons',
  'armor',
  'jewelry',
  'bracelets',
  'resources',
  'courier',
  'mobs',
  'arena',
  'cults',
  'champions',
  'squads',
  'raidBosses',
  'trials',
  'siege',
  'outpost',
  'clans',
  'fortress',
];

// Site-wide survey popup (Google Forms). Toggle here to show/hide the SurveyModal.
export const SURVEY = {
  ENABLED: false,
} as const;

// Home-page ЗБТ (closed beta) invitation popup. Toggle here to show/hide the InfoPopup.
export const ZBT_POPUP = {
  ENABLED: false,
  AUTO_SHOW_DELAY: 6000, // ms before it appears after the home page loads
} as const;

// Admin date filters (payments / promo stats / roulette stats) open on the season start, so the whole
// season is visible without touching the pickers. A FIXED date on purpose — a "July 1 of the current year"
// default would sit in the future from January to June and show empty tables.
export const ADMIN_STATS = {
  DEFAULT_DATE_FROM: '2026-07-01',
} as const;
